import {AfterViewInit, Component, OnInit} from '@angular/core';
@Component({
  selector: 'support-form',
  templateUrl: './support-form.component.html',
  styleUrls: ['./support-form.component.scss']
})
export class SupportFormComponent implements OnInit, AfterViewInit {

  constructor() { }

  ngOnInit() {

  }

  ngAfterViewInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/mmi/support-form/support-form.component.ts